import { Component } from "react";
import { Toaster } from "@/components/ui/sonner";

/**
 * ToasterBoundary — isolates sonner's <Toaster> in its own error boundary.
 * The Toaster is deliberately mounted outside the app-wide ErrorBoundary
 * (so recovery UI still has toasts), which means a toast that throws while
 * rendering would otherwise unmount the ENTIRE React root. On error we log,
 * drop the offending toast by remounting the Toaster (fresh key), and the
 * studio stays on screen.
 */
export default class ToasterBoundary extends Component {
  state = { epoch: 0 };

  static getDerivedStateFromError() {
    return null;
  }

  componentDidCatch(error, info) {
    console.error("[ToasterBoundary] toast render crashed — remounting Toaster:", error, info?.componentStack);
    this.setState((s) => ({ epoch: s.epoch + 1 }));
  }

  render() {
    return <Toaster key={`toaster-${this.state.epoch}`} theme="dark" position="bottom-right" offset="96px" mobileOffset={{ bottom: "140px", left: "16px", right: "16px" }} richColors closeButton />;
  }
}
